import { Form, Divider, Checkbox, Space, Row, Col, Descriptions, Typography } from 'antd';
import StatementPatch from './StatementPatch';
import StatementView from './StatementView';

const { Title } = Typography;

export default function StepSelect({ form, triggerActionsRender, submit }) {
  
  const rowStyle = { border: '1px solid #ccc', textAlign: 'center', padding: '6px' };
  const wrapperCol = { span: 24 };

  const shouldUpdateOnDoPatch = (key, prev, curr) => {
    if (prev?.statements?.[key]?.doPatch !== curr?.statements?.[key]?.doPatch) {
      console.log('prev', prev, 'curr', curr, key);
      return true;
    }
    
    return false;
  }
  
  const shouldUpdateForActions = (prev, curr) => {
    return curr?.statements?.some((statement, index) =>
      (statement.doPatch !== prev?.statements?.[index]?.doPatch)
        || (statement.newStatement !== prev?.statements?.[index]?.newStatement));
  }

  const onFinish = (data) => {
    console.log('statements form submitted', data)
    submit(data);
  };

  const onFinishFailed = (error) => {
    console.log('new error', { ...error });
  };

  return (
    <>
      <Title type="secondary" underline level={3} style={{ textAlign: 'center' }}>
        Select statements to patch
      </Title>
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
      >
        <Form.List name="statements">
            {(fields) => <>
              {fields.map(({ key, name, ...restField }) => <>
                <Row
                  key={key}
                  justify="space-evenly"
                  style={rowStyle}>
                  
                  <Col span={20}>
                    <Form.Item
                      wrapperCol={wrapperCol}
                      shouldUpdate={(prev, curr) => shouldUpdateOnDoPatch(key, prev, curr)}>
                      {() => {
                      return <Space direction='vertical' style={{width: '100%'}}>
                        <StatementView statement={form.getFieldValue('statements')[key].original} />
                        {
                          form.getFieldValue('statements')[key].doPatch
                          ? <>
                            <Divider />
                            <Row>
                              <StatementPatch name={name} restField={restField}/>
                            </Row>
                          </>
                          : <></> }
                          </Space>
                      }}
                    </Form.Item>
                  </Col>
                  
                  <Col span={4}>
                    <Descriptions layout="vertical" bordered column={2} size="small">
                      <Descriptions.Item label="Reporting Cycle" span={2}>
                        { form.getFieldValue('statements')[key]?.original?.reportingCycle }
                      </Descriptions.Item>
                      <Descriptions.Item label="Patch?">
                        <Form.Item
                          {...restField}
                          name={[name, "doPatch"]}
                          wrapperCol={24}
                          valuePropName="checked"
                          >
                          <Checkbox />
                        </Form.Item>
                      </Descriptions.Item>
                      
                      <Descriptions.Item label="New Statement?">
                        <Form.Item
                            {...restField}
                            name={[name, "newStatement"]}
                            wrapperCol={24}
                            valuePropName="checked"
                            >
                            <Checkbox />
                          </Form.Item>
                      </Descriptions.Item>
                    </Descriptions>
                  </Col>
                </Row>
              </>
            )}
          </>}
        </Form.List>
        <Form.Item shouldUpdate={shouldUpdateForActions} wrapperCol="24">
          {() => {
            triggerActionsRender();
          }}
        </Form.Item>
      </Form>
    </>
  );
}